<template>
  <o-dialog
    ref="dialog"
    :title="$t('order.addCustomerCredit')"
    :info="$t('components.order.actions.addCustomerCredit.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('order.addCustomerCredit'), type: 'confirm', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
    :valid="validate"
  >
    <div class="pt-4 text-left">
      <o-form ref="form">
        <o-field-group v-slot="{ status }" :label="$t('order.customerCredit')" :name="$t('order.customerCredit')" class="w-full mb-6" rules="required|min_value:1">
          <currency-field v-model="customerCredit" :status="status" />
        </o-field-group>
      </o-form>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import {
  CurrencyField,
} from '@/components/fields'

interface Props {
  order: Record<string, any>
  portal?: string
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<{
  'update:loading': [value: boolean]
  'update:order': [value: any]
}>()

const { $api, $notification, $i18n } = useNuxtApp()

const dialog = ref<any>(null)
const form = ref<any>(null)

const customerCredit = ref(0)

function open() {
  dialog.value.open()
}

async function confirm() {
  emit('update:loading', true)

  try {
    const credit = customerCredit.value
    const response = await $api.order.addCustomerCredit(String(props.order.idOrder), { price: credit })
    const order = response.data

    emit('update:order', order)

    $notification.toast({
      title: $i18n.t('components.order.actions.addCustomerCredit.success'),
      text: $i18n.t('components.order.actions.addCustomerCredit.successInfo'),
      variant: 'success',
    })

    emit('update:loading', false)

    return true
  } catch (e) {
    console.log(e)
  }

  emit('update:loading', false)
}

function validate() {
  return form.value.validate()
}

defineExpose({ open })
</script>
